export const lang = {
  lang: '中文',
  home: '首页'
}



// WEBPACK FOOTER //
// ./src/assets/lang/zh.js